exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".to-top[data-v-30b3e1ae]{right:0;top:70%;z-index:2}.to-top a[data-v-30b3e1ae]{width:16px;width:1rem;height:16px;height:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/data/efun/gw-template-pre/client/smsgz/assets","/static":"/data/efun/gw-template-pre/client/smsgz/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-30b3e1ae","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/smsgz/components/common/toTop/index.vue
// module id = ISgj
// module chunks = 1